'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gimweb_angular_service = require('../services/gimweb_angular_service.js');

var _gimweb_angular_service2 = _interopRequireDefault(_gimweb_angular_service);

var _location_service = require('../services/location_service.js');

var _location_service2 = _interopRequireDefault(_location_service);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _fundsmarketing_aem_service = require('../services/fundsmarketing_aem_service');

var _fundsmarketing_aem_service2 = _interopRequireDefault(_fundsmarketing_aem_service);

var _string_utility = require('../../../packages/common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _collection_utility = require('../../../packages/common-utilities/src/collection_utility');

var _constants = require('../../../packages/common-utilities/src/constants');

var _state_service = require('../services/state_service');

var _state_service2 = _interopRequireDefault(_state_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var DocumentLink = function (_React$Component) {
  _inherits(DocumentLink, _React$Component);

  function DocumentLink(props) {
    _classCallCheck(this, DocumentLink);

    var _this = _possibleConstructorReturn(this, (DocumentLink.__proto__ || Object.getPrototypeOf(DocumentLink)).call(this, props));

    _this.onSubscriptionCTAMouseOver = function () {
      _this.setState({ onSubscriptionBtnHover: true });
    };

    _this.onSubscriptionCTAMouseLeave = function () {
      _this.setState({ onSubscriptionBtnHover: false });
    };

    _this.toggleSubscriptionButton = function (toggleId) {
      _this.setState(function (prevState) {
        return {
          subscriptionInputs: _extends({}, prevState.subscriptionInputs, _defineProperty({}, toggleId, !prevState.subscriptionInputs[toggleId]))
        };
      });
    };

    _this.renderPopover = function () {
      return _this.state.onSubscriptionBtnHover && _react2.default.createElement(
        'div',
        { className: 'popover dark left-pos font-black-variant caption text-left', role: 'tooltip', 'aria-live': 'polite' },
        _react2.default.createElement(
          'p',
          { id: 'popover-description', tabIndex: 0 },
          _string_utility2.default.getLocalizedString(_this.props.intl, "Get notified when updated literature is available", 'pdp-cta-subscribe-to-product-literature')
        ),
        _react2.default.createElement('div', { className: 'popover-arrow dark left-pos', 'aria-hidden': 'true' })
      );
    };

    _this.renderLoggedInSubscriptionButton = function (toggleId, isMobileBreakpoint) {
      var hoverClass = '' + (_this.state.onSubscriptionBtnHover ? "hover" : "");
      var subscriptionClass = '' + (_this.state.subscriptionInputs[toggleId] ? "subscribed" : "unsubscribed");
      var subscriptionToggle = _react2.default.createElement(
        'span',
        { className: 'toggle-switch float-right' },
        _react2.default.createElement('input', { type: 'button', id: toggleId, className: 'toggle-checkbox', checked: _this.state.subscriptionInputs[toggleId] || false }),
        _react2.default.createElement(
          'label',
          { htmlFor: toggleId, className: 'toggle-label logged-in ' + subscriptionClass + ' ' + hoverClass + ' ' + (isMobileBreakpoint ? "margin-top-5" : ""), 'data-testid': 'subscription-button-logged-in' },
          !isMobileBreakpoint && _this.renderPopover(),
          _react2.default.createElement('span', { className: 'toggle-slider logged-in ' + subscriptionClass + ' ' + hoverClass }),
          !isMobileBreakpoint && _react2.default.createElement(
            'span',
            { className: 'toggle-text ' + subscriptionClass + ' ' + hoverClass },
            _this.state.subscriptionInputs[toggleId] ? "Subscribed" : "Subscribe"
          )
        )
      );
      return _react2.default.createElement(
        'a',
        {
          href: '#',
          'data-testid': 'subscription-logged-in',
          style: { justifyContent: 'flex-end', width: isMobileBreakpoint ? '70px' : '150px' },
          className: "display-inline-block padding-right-10 float-right" + (isMobileBreakpoint ? " margin-left-10 padding-bottom-10" : ""),
          onMouseLeave: _this.onSubscriptionCTAMouseLeave,
          onMouseOver: _this.onSubscriptionCTAMouseOver,
          onClick: _this.handleSubscriptionToggle(toggleId)
        },
        subscriptionToggle
      );
    };

    _this.handleSubscriptionToggle = function (toggleId) {
      return function (e) {
        e.preventDefault();
        var action = _this.state.subscriptionInputs[toggleId] ? "Unsubscribe - " : "Subscribe - ";

        _state_service2.default.updateModalState({
          modalConfig: {
            display: 'inline-block',
            modalType: 'loading-bg-w'
          }
        });
        setTimeout(function () {
          _state_service2.default.updateModalState({ modalConfig: { display: 'none' } });
          _this.toggleSubscriptionButton(toggleId);
        }, 500);

        _tracking_utility.TrackingUtility.trackEvent({
          "eventCategory": "pdp",
          "eventAction": action + _this.props.fundDocument.title,
          "eventLabel": 'from: '.concat(window.location.href)
        });
      };
    };

    _location_service2.default.setTargetWindowObject(props.window);
    _this.renderLink = _this.renderLink.bind(_this);
    _this.trackGA = _this.trackGA.bind(_this);
    _this.state = {
      subscriptionInputs: {}
    };
    return _this;
  }

  _createClass(DocumentLink, [{
    key: 'renderChildren',
    value: function renderChildren() {
      var _this2 = this;

      if (!(0, _functional_utility.isDataEmpty)(this.props.fundDocument.childDoc)) {
        return _react2.default.createElement(
          'ul',
          { className: 'list-unstyled-no-padding padding-horizontal-0' },
          mapIndexed(function (fundDocument, index) {
            return _react2.default.createElement(
              'li',
              { key: index },
              _react2.default.createElement(DocumentLink, { fundDocument: fundDocument,
                userLoggedIn: _this2.props.userLoggedIn,
                child: 'true',
                basePath: _this2.props.basePath,
                intl: _this2.props.intl
              })
            );
          }, this.props.fundDocument.childDoc)
        );
      }
    }
  }, {
    key: 'renderChildIcon',
    value: function renderChildIcon() {
      if (this.props.child === "true") {
        return _react2.default.createElement('span', { 'data-testid': 'document-icon', className: 'icon icon-minus text-top margin-right-5 vertical-align-middle' });
      }
      return "";
    }
  }, {
    key: 'trackGA',
    value: function trackGA(url) {
      if (this.props.headerTitleId.indexOf("insights") === -1) {
        _tracking_utility.TrackingUtility.trackEvent(_tracking_utility.TrackingUtility.getDownloadsTracking(url, window.location.href));
      }
    }
  }, {
    key: 'renderLoggedOutSubscriptionButton',
    value: function renderLoggedOutSubscriptionButton(toggleId, redirectLoginURL, MobileBreakpoint) {
      var desktopLoggedOutSubscriptionIcon = _react2.default.createElement(
        'span',
        { className: 'toggle-switch float-right' },
        _react2.default.createElement('input', { type: 'button', id: toggleId, className: 'toggle-checkbox' }),
        _react2.default.createElement(
          'label',
          { htmlFor: toggleId, className: 'toggle-label', 'data-testid': 'subscription-button-logged-out' },
          _react2.default.createElement('span', { className: 'toggle-slider' })
        )
      );
      var mobileLoggedOutSubscriptionIcon = _react2.default.createElement('span', { className: 'vertical-align-middle icon-bell-logged-out-cta', 'data-testid': 'icon-subscription-logged-out-bell' });
      return _react2.default.createElement(
        'a',
        {
          href: redirectLoginURL,
          'data-testid': 'subscription-logged-out',
          target: '_self',
          style: { justifyContent: 'flex-end', width: '13%' },
          className: "display-inline-block padding-right-10 float-right" + (MobileBreakpoint ? " padding-bottom-10" : ""),
          onClick: function onClick() {
            return _tracking_utility.TrackingUtility.trackEvent({
              "eventCategory": "pdp",
              "eventAction": "Locked Subscribe",
              "eventLabel": 'from: '.concat(window.location.href)
            });
          } },
        this.props.breakpoint < 4 ? mobileLoggedOutSubscriptionIcon : desktopLoggedOutSubscriptionIcon
      );
    }
  }, {
    key: 'renderDownloadIconSubscriptionHyperlink',
    value: function renderDownloadIconSubscriptionHyperlink(fundDocument, MobileBreakpoint) {
      var _this3 = this;

      var adjustedWidthMobile = this.props.breakpoint < 4 ? '7%' : '3%';
      return _react2.default.createElement('a', { className: "vertical-align-middle icon-download margin-right-10 float-right" + (MobileBreakpoint ? "" : " padding-right-3"),
        style: { justifyContent: 'flex-end', width: '' + adjustedWidthMobile },
        href: fundDocument.docURL,
        onClick: function onClick() {
          return _this3.trackGA(fundDocument.docURL);
        },
        'aria-label': this.props.fundDocument.title + _string_utility2.default.getLocalizedString(this.props.intl, ' opens in new tab/window', "open-new-window"),
        tabIndex: '0',
        'data-testid': 'document-link'
      });
    }
  }, {
    key: 'renderLink',
    value: function renderLink() {
      var _this4 = this;

      var _props = this.props,
          fundDocument = _props.fundDocument,
          userLoggedIn = _props.userLoggedIn,
          basePath = _props.basePath,
          role = _props.role,
          isAEM = _props.isAEM,
          defaultStyle = _props.defaultStyle,
          textColorClass = _props.textColorClass,
          country = _props.country,
          language = _props.language;

      var isMobilePath = _location_service2.default.isMobile(basePath) || _location_service2.default.isMobileInsight(basePath);
      var MobileBreakpoint = (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint);
      var isOrion = role === "xmobile";
      var isOrionOrMobilePath = isOrion || isMobilePath;
      var userNotLoggedInAndGlassDoor = (0, _ramda.and)(!userLoggedIn, fundDocument.isGlassDoor);
      var isCountryRoleSpecificSubscriptionEnabled = this.props.headerTitleId === "fundLiteratureDocuments" && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHOW_DOCUMENT_TAB_SUBSCRIPTION_BUTTON") && _collection_utility.CollectionUtility.includes((0, _ramda.pathOr)([], [country, language, role], _constants.SUBSCRIPTION_COUNTRY_ROLE_ALLOWED_DOCUMENT_TYPE), this.props.fundDocument.documentType);
      var toggleId = 'toggle-' + this.props.fundDocument.title;
      var redirectLoginURL = this.props.cmsHost + "/us/en/asset-management/adv/auth/login-form/";
      var additionalAttributes = {};
      var documentHyperlink = _react2.default.createElement(
        'a',
        { className: defaultStyle + " text-left text-primary hover-underline" + (MobileBreakpoint ? " padding-left-5" : ""),
          tabIndex: '0',
          'data-testid': 'document-link',
          href: fundDocument.docURL,
          onClick: function onClick() {
            return _this4.trackGA(fundDocument.docURL);
          },
          target: '_blank',
          'aria-label': this.props.fundDocument.title + _string_utility2.default.getLocalizedString(this.props.intl, ' opens in new tab/window', "open-new-window") },
        this.renderChildIcon(),
        _react2.default.createElement(
          'span',
          { 'data-testid': 'document-title',
            className: textColorClass + " vertical-align-middle" + (isCountryRoleSpecificSubscriptionEnabled && !MobileBreakpoint ? " padding-left-10" : "") },
          this.props.fundDocument.title
        ),
        !isCountryRoleSpecificSubscriptionEnabled && _react2.default.createElement('span', { className: 'vertical-align-middle icon-download margin-left-10 float-right' })
      );

      if (!isOrionOrMobilePath) {
        additionalAttributes.onClick = function (e) {
          _this4.gatedGoToDocument(e, isAEM);
        };
      }

      if (userNotLoggedInAndGlassDoor) {
        return _react2.default.createElement(
          'a',
          _extends({ className: defaultStyle + " text-left text-primary hover-underline",
            tabIndex: '0',
            'data-testid': 'document-link',
            href: isOrionOrMobilePath ? fundDocument.docURL : "#",
            target: '_blank',
            'aria-label': this.props.fundDocument.title + _string_utility2.default.getLocalizedString(this.props.intl, ' opens in new tab/window', "open-new-window")
          }, additionalAttributes),
          this.renderChildIcon(),
          _react2.default.createElement(
            'span',
            { 'data-testid': 'document-title',
              className: textColorClass + " vertical-align-middle text" },
            this.props.fundDocument.title
          ),
          _react2.default.createElement(
            'span',
            { className: "display-flex vertical-align-middle" },
            isOrion ? "" : _react2.default.createElement('span', { 'data-testid': 'document-icon', className: 'icon-glassdoor margin-right-5' }),
            _react2.default.createElement('span', { className: 'icon-download float-right' })
          )
        );
      }

      if (!(0, _ramda.isNil)(this.props.leavingSiteOverlay) && _fundsmarketing_aem_service2.default.isExternalSite(fundDocument.docURL)) {
        return _react2.default.createElement(
          'a',
          { className: defaultStyle + " text-left text-primary hover-underline",
            tabIndex: '0',
            'data-testid': 'document-link',
            href: '#',
            onClick: function onClick(event) {
              _fundsmarketing_aem_service2.default.invokeExtLinkConfirmWindow(fundDocument.docURL);
              _this4.trackGA(fundDocument.docURL);
              event.preventDefault();
            } },
          this.renderChildIcon(),
          _react2.default.createElement(
            'span',
            { 'data-testid': 'document-title', className: textColorClass + " vertical-align-middle" },
            this.props.fundDocument.title
          ),
          _react2.default.createElement('span', { className: 'vertical-align-middle icon-download margin-left-10 float-right' })
        );
      } else {
        return isCountryRoleSpecificSubscriptionEnabled ? _react2.default.createElement(
          'div',
          { className: 'row full-width display-inline-flex', 'data-testid': 'document-row-with-subscription' },
          documentHyperlink,
          this.props.userLoggedIn ? this.renderLoggedInSubscriptionButton(toggleId, MobileBreakpoint) : this.renderLoggedOutSubscriptionButton(toggleId, redirectLoginURL, MobileBreakpoint),
          this.renderDownloadIconSubscriptionHyperlink(fundDocument, MobileBreakpoint)
        ) : documentHyperlink;
      }
    }
  }, {
    key: 'gatedGoToDocument',
    value: function gatedGoToDocument(e, isAEM) {
      if (e) {
        e.preventDefault();
      }
      if (isAEM) {
        _fundsmarketing_aem_service2.default.invokeLoginModal();
      } else {
        _gimweb_angular_service2.default.invokeGIMLoginModal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isLastRow = this.props.isLastRow;

      var divMarginPadding = this.props.divClass ? this.props.divClass : 'margin-top-5 margin-vertical-0 padding-vertical-10';
      return _react2.default.createElement(
        'div',
        { className: 'document-link ' + divMarginPadding + ' ' + (isLastRow ? "" : "border-bottom-1 border-light-grey") },
        _react2.default.createElement('span', { className: 'vertical-align-middle align-self-center ct-icon ct-icon-download margin-right-10' }),
        this.renderLink(),
        this.renderChildren()
      );
    }
  }]);

  return DocumentLink;
}(_react2.default.Component);

exports.default = DocumentLink;